export default __webpack_public_path__ + "static/media/card.d56c6802.png";